import axios from 'axios'
import apiConfiguration from '../utilities/api/apiConfiguration'
import {getClientIdByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const CREATE_RESTAURANT_RESERVATION_BEGIN = 'CREATE_RESTAURANT_RESERVATION_BEGIN'
export const CREATE_RESTAURANT_RESERVATION_SUCCESS = 'CREATE_RESTAURANT_RESERVATION_SUCCESS'
export const CREATE_RESTAURANT_RESERVATION_ERROR = 'CREATE_RESTAURANT_RESERVATION_ERROR'

export const createRestaurantReservationBegin = ({
	type: CREATE_RESTAURANT_RESERVATION_BEGIN
})

export const createRestaurantReservationSuccess = confirmation => ({
	type: CREATE_RESTAURANT_RESERVATION_SUCCESS,
	payload: confirmation
})

export const createRestaurantReservationError = error => ({
	type: CREATE_RESTAURANT_RESERVATION_ERROR,
	payload: { error }
})


export default function createRestaurantReservation(currentRestaurant) {
	return (dispatch, getState) => {
		const currentGuest = getState().form.guestForm
    const urlData = getState().availabilityData.urlData;
    
    let currentClientId = getClientIdByHotelCode(urlData.hotelCode);

		// URL Params
		let urlParams = {
			clientId: currentClientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		const reservationEntry = {
			createParameters: {
				type: currentRestaurant.type,
				venueId: currentRestaurant.venueId,
				date: currentRestaurant.date,
				time: currentRestaurant.time,
				partySize: currentRestaurant.party,
				firstName: currentGuest.values.firstName,
				lastName: currentGuest.values.lastName,
				phone: currentGuest.values.phone,
				email: currentGuest.values.email
			}
		}

		// Base API path
		let apiBase = 'https://sbe.dolli.cloud/api/restaurant/reservations?' + fetchQuery.toString()

		// Begin create restaurant reservation set loading true & error false
		dispatch(createRestaurantReservationBegin)

		axios.post(apiBase, JSON.stringify(reservationEntry), apiConfiguration())
		.then((response) => {
			const currentRestaurantConfirmation = {}

			currentRestaurantConfirmation[response.data.data.id] = {
				id: response.data.data.id,
				reservation: response.data.data,
				venue: response.data.venue,
				status: 'APPROVED'
			}

			dispatch(createRestaurantReservationSuccess(currentRestaurantConfirmation))
		})
		.catch(error => dispatch(createRestaurantReservationError(error)))
	}
}



// WEBPACK FOOTER //
// ./src/actions/createRestaurantReservation.js